import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import { SimpleLoadingComponent } from '../../utils/apollo';
import RepVisitsNotificationsFrame from '../../components/RepVisitsNotificationsFrame';

export const NotificationsAndTaskaQuery = gql`
  query HEAccount {
    viewer {
        id
        heAccount {
          id
          activeSubscriptions
        }
    }
  }
`;

const graphqlData = graphql(NotificationsAndTaskaQuery);

export default SimpleLoadingComponent(graphqlData)(RepVisitsNotificationsFrame);
